import "./App.css";
import PortalApp from "./portal/PortalApp";

export default function App() {
  return <PortalApp />;
}
